<div
    class="itsl-common-pager-item">
    {#if id >= 0}
        <button
            id={`page-${id}-${guidV4()}`}
            type="button"
            aria-label={ariaLabel}
            aria-current={ariaCurrent}
            class="itsl-common-pager-item__button {cssClass}"
            on:click={onPageItemClick}>
            <span
                class="itsl-common-pager-item__button-text"
                class:itsl-common-pager-item__button-text--selected={isSelected}>
                {id + 1}
            </span>
        </button>
    {:else}
        <button
            id={`page-${id}-${guidV4()}`}
            type="button"
            disabled
            aria-hidden="true"
            class="itsl-common-pager-item__button">
            <span class="itsl-common-pager-item__button-text">
                {text}
            </span>
        </button>
    {/if}
</div>

<script>
    import { guidV4 } from '@itslearning/atlas/generate/guid';
    import { formatLanguageString } from '@itslearning/atlas/strings/format';
    import { createEventDispatcher } from 'svelte';

    export let id = 0;
    export let text = '';
    export let isSelected = false;
    export let i18n;
    export let cssClass = '';

    const dispatch = createEventDispatcher();

    $: ariaLabel = isSelected ? formatLanguageString(i18n.searchResultsPagingCurrentResults, text) : text;
    $: ariaCurrent = isSelected ? "page" : "";

    function onPageItemClick() {
        dispatch('pageSelected', { id });
    }
</script>
